// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__gNV_F","list_item":"styles_list_item__2rApI","more":"styles_more__3uWou"};